import React from "react";
import PropTypes from "prop-types";
import { Link as GatsbyLink } from "gatsby";
import { css } from "@emotion/react";

import { baseColor2 } from "../styles/color";

const Link = (props) => {
  const linkStyles = css`
    color: ${props.color};
    text-decoration-style: dashed;
    text-decoration-thickness: 2px;
    text-underline-offset: 3px;

    &:hover {
      text-decoration-style: solid;
      color: ${props.hoverColor || props.color};
    }
  `;

  return props.external ? (
    <a css={linkStyles} href={props.to} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  ) : (
    <GatsbyLink css={linkStyles} to={props.to}>
      {props.children}
    </GatsbyLink>
  );
};

Link.defaultProps = {
  color: baseColor2,
  hoverColor: undefined,
  external: false,
  to: "/",
  children: <span>go home</span>,
};

Link.propTypes = {
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  external: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Link;
